import { type TransactionHash, type TokenId, TRANSACTION_TYPES, EVENT_SUFFIXES } from "@/types";
import { createEventEmitter } from "@/events";

export const MINT_EVENTS = {
    SUCCESS: `${TRANSACTION_TYPES.MINT}:${EVENT_SUFFIXES.SUCCESS}`,
} as const;

export interface MintSuccessPayload {
    transactionHash: TransactionHash;
    mintTokenId: TokenId;
    mintAmount: number;
}

export interface MintEventPayloads extends Record<string, unknown> {
    [MINT_EVENTS.SUCCESS]: MintSuccessPayload;
}

export const mintEventEmitter = createEventEmitter<MintEventPayloads>();
